import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const LogoDashboard = () => import("@/views/LogoDashboard");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
//const WasteRequest = () => import('@/views/WasteRequest')
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");

const Profile = () => import("@/views/profile/Profile");

const Role_lists = () => import("@/views/manage_roles/Role_lists");
const Add_roles = () => import("@/views/manage_roles/Add_roles");
const Edit_roles = () => import("@/views/manage_roles/Edit_roles");

const Manage_users = () => import("@/views/manage_users/Manage_users");
const Add_users = () => import("@/views/manage_users/Add_users");
const Edit_users = () => import("@/views/manage_users/Edit_users");

const Manage_modules = () => import("@/views/manage_modules/Manage_modules");
const Add_modules = () => import("@/views/manage_modules/Add_modules");
const Edit_modules = () => import("@/views/manage_modules/Edit_modules");

const Manage_wastes = () => import("@/views/manage_waste/Manage_wastes");
const Add_waste = () => import("@/views/manage_waste/Add_waste");
const Edit_waste = () => import("@/views/manage_waste/Edit_waste");
const ViewWasteRequest = () => import("@/views/manage_waste/ViewWasteRequest");

const Marketing_dashboard = () =>
  import("@/views/marketing_dashboard/Marketing_dashboard");
const Email_Template = () => import("@/views/email_template/Email_template");
const Push_Notification = () =>
  import("@/views/push_notification/Push_Notification");
const Payment_advices = () => import("@/views/payment_advice/Payment_advices");

const Waste_lifting_lists = () =>
  import("@/views/manage_waste_lifting/Waste_lifting_lists");
const Add_waste_lifting = () =>
  import("@/views/manage_waste_lifting/Add_waste_lifting");
const Edit_waste_lifting = () =>
  import("@/views/manage_waste_lifting/Edit_waste_lifting");

const GPS_lists = () => import("@/views/gps/GPS_lists");
const Add_GPS = () => import("@/views/gps/Add_GPS");
const Edit_GPS = () => import("@/views/gps/Edit_GPS");

const Manage_devices = () => import("@/views/manage_devices/Manage_devices");
const Add_devices = () => import("@/views/manage_devices/Add_device");

const Origin_masters = () => import("@/views/all_masters/Origin_masters");
const Add_origin = () => import("@/views/all_masters/Add_origin");
const Edit_origin = () => import("@/views/all_masters/Edit_origin");

const Destination_masters = () =>
  import("@/views/all_masters/Destination_masters");
const Add_destination = () => import("@/views/all_masters/Add_destination");
const Edit_destination = () => import("@/views/all_masters/Edit_destination");

const Vehical_masters = () => import("@/views/all_masters/Vehical_masters");
const Add_vehical = () => import("@/views/all_masters/Add_vehical");
const Edit_vehical = () => import("@/views/all_masters/Edit_vehical");

const Manage_assign_module = () =>
  import("@/views/assign_modules/Manage_assign_module");
const Assign_module = () => import("@/views/assign_modules/Assign_module");
const Edit_assign_module = () =>
  import("@/views/assign_modules/Edit_assign_module");

const Device_masters = () => import("@/views/all_masters/Device_masters");
const Add_device = () => import("@/views/all_masters/Add_device");
const Edit_device = () => import("@/views/all_masters/Edit_device");

const Material_masters = () => import("@/views/all_masters/Material_masters");
const Add_material = () => import("@/views/all_masters/Add_material");
const Edit_material = () => import("@/views/all_masters/Edit_material");

const Texure_masters = () => import("@/views/all_masters/Texure_masters");
const Add_texure = () => import("@/views/all_masters/Add_texure");
const Edit_texure = () => import("@/views/all_masters/Edit_texure");

const Driver_masters = () => import("@/views/all_masters/Driver_masters");
const Add_driver = () => import("@/views/all_masters/Add_driver");
const Edit_driver = () => import("@/views/all_masters/Edit_driver");

const Packaging_masters = () => import("@/views/all_masters/Packaging_masters");
const Add_packaging = () => import("@/views/all_masters/Add_packaging");
const Edit_packaging = () => import("@/views/all_masters/Edit_packaging");

const Statuses_masters = () => import("@/views/all_masters/Statuses_masters");
const Add_statuses = () => import("@/views/all_masters/Add_statuses");
const Edit_statuses = () => import("@/views/all_masters/Edit_statuses");

const Manage_feedback_module = () =>
  import("@/views/feedback/Manage_feedback_module");
const Add_questions = () => import("@/views/feedback/Add_questions");
const Edit_questions = () => import("@/views/feedback/Edit_questions");

const Manage_feedback_answer_module = () =>
  import("@/views/feedback_answer/Manage_feedback_answer_module");

const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
//const Login = () => import('@/views/pages/Login')
//const Register = () => import('@/views/pages/Register')
const Login = () => import("@/views/Login");
const Register = () => import("@/views/Register");
const Forgotpassword = () => import("@/views/Forgotpassword");

// Users
const Users = () => import("@/views/users/Users");
const User = () => import("@/views/users/User");

const Notification = () => import("@/views/Notification");

Vue.use(Router);

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/login",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "dashboard",
          name: "LogoDashboard",
          component: LogoDashboard,
        },
        {
          path: "profile",
          name: "Profile",
          component: Profile,
        },
        {
          path: "/add_roles",
          name: "Add roles",
          component: Add_roles,
        },
        {
          path: "/edit_roles",
          name: "Edit roles",
          component: Edit_roles,
        },
        {
          path: "/role_lists",
          name: "Role lists",
          component: Role_lists,
        },
        {
          path: "/add_users",
          name: "Add users",
          component: Add_users,
        },
        {
          path: "/edit_users",
          name: "Edit users",
          component: Edit_users,
        },
        {
          path: "/manage_users",
          name: "Manage users",
          component: Manage_users,
        },
        {
          path: "/add_modules",
          name: "Add modules",
          component: Add_modules,
        },
        {
          path: "/edit_modules",
          name: "Edit modules",
          component: Edit_modules,
        },
        {
          path: "/manage_modules",
          name: "Manage modules",
          component: Manage_modules,
        },
        {
          path: "/add_waste",
          name: "Add waste",
          component: Add_waste,
        },
        {
          path: "/edit_waste",
          name: "Edit waste",
          component: Edit_waste,
        },
        {
          path: "/viewWasteRequest",
          name: "View Waste Request",
          component: ViewWasteRequest,
        },
        {
          path: "/manage_wastes",
          name: "Manage Waste",
          component: Manage_wastes,
        },
        {
          path: "/marketing_dashboard",
          name: "Marketing Dashboard",
          component: Marketing_dashboard,
        },
        {
          path: "/email_template",
          name: "Manage Email Templates",
          component: Email_Template,
        },
        {
          path: "/push_notification",
          name: "Manage Push Notifications",
          component: Push_Notification,
        },
        {
          path: "/manage_assign_module",
          name: "Manage_assign_module",
          component: Manage_assign_module,
        },
        {
          path: "/assign_module",
          name: "Assign Module",
          component: Assign_module,
        },
        {
          path: "/edit_assign_module",
          name: "Edit Assign Module",
          component: Edit_assign_module,
        },
        {
          path: "/add_waste_lifting",
          name: "Add waste",
          component: Add_waste_lifting,
        },
        {
          path: "/edit_waste_lifting",
          name: "Edit waste",
          component: Edit_waste_lifting,
        },
        {
          path: "/waste_lifting_lists",
          name: "Manage Waste",
          component: Waste_lifting_lists,
        },
        {
          path: "/payment_advices",
          name: "Payment Advice",
          component: Payment_advices,
        },
        {
          path: "/add_GPS",
          name: "Add GPS",
          component: Add_GPS,
        },
        {
          path: "/edit_GPS",
          name: "Edit GPS",
          component: Edit_GPS,
        },
        {
          path: "/GPS_lists",
          name: "GPS lists",
          component: GPS_lists,
        },
        {
          path: "/add_device",
          name: "Add device",
          component: Add_devices,
        },
        {
          path: "/manage_devices",
          name: "Manage device",
          component: Manage_devices,
        },
        {
          path: "/notification",
          name: "Notification",
          component: Notification,
        },
        {
          path: "/manage_feedback_module",
          name: "Manage Feedback Module",
          component: Manage_feedback_module,
        },
        {
          path: "/add_questions",
          name: "Add Questions",
          component: Add_questions,
        },
        {
          path: "/edit_questions",
          name: "Edit Questions",
          component: Edit_questions,
        },
        {
          path: "/manage_feedback_answer_module",
          name: "Manage Feedback Answer Module",
          component: Manage_feedback_answer_module,
        },
        {
          path: "all_masters",
          redirect: "/all_masters/Origin_masters",
          name: "All Masters",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "origin_masters",
              name: "Origin Masters",
              component: Origin_masters,
            },
            {
              path: "add_origin",
              name: "Add Origin",
              component: Add_origin,
            },
            {
              path: "edit_origin",
              name: "Edit Origin",
              component: Edit_origin,
            },
            {
              path: "destination_masters",
              name: "Destination Masters",
              component: Destination_masters,
            },
            {
              path: "add_destination",
              name: "Add Destination",
              component: Add_destination,
            },
            {
              path: "edit_destination",
              name: "Edit Destination",
              component: Edit_destination,
            },
            {
              path: "vehical_masters",
              name: "Vehical Masters",
              component: Vehical_masters,
            },
            {
              path: "add_vehical",
              name: "Add Vehical",
              component: Add_vehical,
            },
            {
              path: "edit_vehical",
              name: "Edit Vehical",
              component: Edit_vehical,
            },
            {
              path: "device_masters",
              name: "Device Masters",
              component: Device_masters,
            },
            {
              path: "add_device",
              name: "Add Device",
              component: Add_device,
            },
            {
              path: "edit_device",
              name: "Edit Device",
              component: Edit_device,
            },
            {
              path: "material_masters",
              name: "Material Masters",
              component: Material_masters,
            },
            {
              path: "add_material",
              name: "Add Material",
              component: Add_material,
            },
            {
              path: "edit_material",
              name: "Edit Material",
              component: Edit_material,
            },
            {
              path: "texure_masters",
              name: "Texure Masters",
              component: Texure_masters,
            },
            {
              path: "add_texure",
              name: "Add Texure",
              component: Add_texure,
            },
            {
              path: "edit_texure",
              name: "Edit Texure",
              component: Edit_texure,
            },
            {
              path: "driver_masters",
              name: "Driver Masters",
              component: Driver_masters,
            },
            {
              path: "add_driver",
              name: "Add Driver",
              component: Add_driver,
            },
            {
              path: "edit_driver",
              name: "Edit Driver",
              component: Edit_driver,
            },
            {
              path: "packaging_masters",
              name: "Driver Packaging",
              component: Packaging_masters,
            },
            {
              path: "add_packaging",
              name: "Add Packaging",
              component: Add_packaging,
            },
            {
              path: "edit_packaging",
              name: "Edit Packaging",
              component: Edit_packaging,
            },
            {
              path: "statuses_masters",
              name: "Statuses Masters",
              component: Statuses_masters,
            },
            {
              path: "add_statuses",
              name: "Add Statuses",
              component: Add_statuses,
            },
            {
              path: "edit_statuses",
              name: "Edit Statuses",
              component: Edit_statuses,
            },
          ],
        },
        {
          path: "theme",
          redirect: "/theme/colors",
          name: "Theme",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
          ],
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },
        {
          path: "users",
          meta: {
            label: "Users",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Users",
              component: Users,
            },
            {
              path: ":id",
              meta: {
                label: "User Details",
              },
              name: "User",
              component: User,
            },
          ],
        },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/coreui-icons",
          name: "CoreUI Icons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "coreui-icons",
              name: "Icons library",
              component: CoreUIIcons,
            },
            {
              path: "brands",
              name: "Brands",
              component: Brands,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
      ],
    },
    {
      path: "/",
      redirect: "/login",
      name: "Login",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
        {
          path: "forgotpassword",
          name: "Forgot password",
          component: Forgotpassword,
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },
  ];
}
